import {
  Box,
  FormControl,
  InputLabel,
  Select,
  SelectProps,
  Skeleton,
} from "@mui/material";

import { Ref, forwardRef } from "react";
import { ValidationMessage } from "../ValidationMessage";

type SelectFieldProps = {
  helpertext?: string;
  loading?: boolean;
  shrinkLabel?: boolean;
  datacy: string;
  style?: React.CSSProperties;
} & SelectProps;

export const SelectField = forwardRef(
  (
    {
      helpertext,
      loading,
      shrinkLabel,
      datacy,
      style,
      ...selectFieldProps
    }: SelectFieldProps,
    ref: Ref<HTMLInputElement>,
  ) => {
    return (
      <Box style={style}>
        {loading ? (
          <Skeleton variant="rectangular" height={56} />
        ) : (
          <FormControl fullWidth size={selectFieldProps.size}>
            <InputLabel id={selectFieldProps.id} shrink={shrinkLabel}>
              {selectFieldProps.label}
              {selectFieldProps.required && " *"}
            </InputLabel>
            <Select
              fullWidth
              {...selectFieldProps}
              inputRef={ref}
              inputProps={{ "data-cy": datacy }}
            />
          </FormControl>
        )}
        {helpertext && <ValidationMessage message={helpertext} />}
      </Box>
    );
  },
);

export default SelectField;
